enum QHPNetworkTypeEnum {
  All = "All Networks",
  HealthPlans = "Qualified Health Plan (QHP)",
  DentalOnlyPlans = "Stand-Alone Dental Plan (SADP)",
}
  
export { QHPNetworkTypeEnum };
  